<template>
    <div>
        <app-back-button v-if="backButton" />
        <div v-if="pageOverline" class="overline mb-n1">{{ pageOverline }}</div>
        <h1
            v-if="findSlot('heading') || pageHeading"
            v-test-id="`platform-heading1`"
            :class="{
                'text-h3': !large,
                'text-h1': large
            }"
        >
            <slot v-if="findSlot('heading')" name="heading" />
            <span v-else>{{ pageHeading }}</span>
        </h1>
        <h2
            v-if="findSlot('subheading') || pageSubheading"
            v-test-id="`platform-heading2`"
            class="mt-n1"
            :class="{
                'text-h5': !large,
                'text-h3': large
            }"
        >
            <slot v-if="findSlot('subheading')" name="subheading" />
            <span v-else style="filter: brightness(1.2)">{{ pageSubheading }}</span>
        </h2>
        <p v-if="pageDescription" v-test-id="`platform-description`" class="mb-0" style="max-width: 50rem">
            {{ pageDescription }}
        </p>
    </div>
</template>

<script>
export default {
    name: 'AppPageHeader',
    components: {
        AppBackButton: () =>
            import(
                /* webpackChunkName: "core" */
                '@/components/AppBackButton'
            )
    },
    props: {
        heading: {
            type: [String, Boolean],
            default: null
        },
        subheading: {
            type: [String, Boolean],
            default: null
        },
        description: {
            type: [String, Boolean],
            default: null
        },
        overline: {
            type: [String, Boolean],
            default: null
        },
        backButton: {
            type: Boolean,
            default: false
        },
        large: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        pageHeading() {
            if (this.heading === false) {
                return false;
            }

            if (this.heading) {
                return this.heading;
            }

            return this.$route.meta.heading;
        },
        pageSubheading() {
            if (this.subheading === false) {
                return false;
            }

            if (this.subheading) {
                return this.subheading;
            }

            return this.$route.meta.subheading;
        },
        pageDescription() {
            if (this.description === false) {
                return false;
            }

            if (this.description) {
                return this.description;
            }

            return this.$route.meta.description;
        },
        pageOverline() {
            if (this.overline === false) {
                return false;
            }

            if (this.overline) {
                return this.overline;
            }

            return this.$route.meta.overline;
        }
    }
};
</script>
